// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "flightCard__footer-6-1FQ";
var _4 = "flightCard__aircraftName-MhR5L";
var _5 = "flightCard__airlineLogo-J2RmN";
var _6 = "flightCard__airlineNumber-3IOA0";
var _7 = "flightCard__flightBlock-3JTxk";
var _8 = "flightCard__flightTitle-2TQZ-";
var _9 = "flightCard__flightValue-aRJ1s";
var _a = "flightCard__icon-2wITu";
export { _1 as "__esModule", _2 as "mobile", _3 as "flightCard__footer", _4 as "flightCard__aircraftName", _5 as "flightCard__airlineLogo", _6 as "flightCard__airlineNumber", _7 as "flightCard__flightBlock", _8 as "flightCard__flightTitle", _9 as "flightCard__flightValue", _a as "flightCard__icon" }
export default { "__esModule": _1, "mobile": _2, "flightCard__footer": _3, "flightCard__aircraftName": _4, "flightCard__airlineLogo": _5, "flightCard__airlineNumber": _6, "flightCard__flightBlock": _7, "flightCard__flightTitle": _8, "flightCard__flightValue": _9, "flightCard__icon": _a }
